export default __webpack_public_path__ + "img/6d521002b976b379fe0379ba48114e12.png";